import { graphqlApolloClient } from "../graphql-apollo-client"
import { UPDATE_ASSISTANCE } from "./graphql/update-assistance"

export const updateAssistance = async ({ id, hasAssist }) => {
  const result = await graphqlApolloClient.mutate({
    mutation: UPDATE_ASSISTANCE,
    variables: {
      id,
      hasAssist
    }
  })

  return result.data.UpdateAssistance
}
